const MESSAGES = {
  ERROR: 'Some error occurred',
  ERROR_ATTACHMENT_CREATION:
    'Some error occurred, while creating an attachment',
  DUPLICATE_EMAIL: 'User already exists with the same email',
  DUPLICATE_PHONE: 'User already exists with the same phone number',
  APP_ERROR: 'Something went wrong at our end, please try again',
  VERIFICATION_SUCCESS: 'Verification is successfully done.',
  RESET_LINK_SENT: 'We have sent reset password link to your email address',
  PWd_RESET_SUCESS:
    'You password has been rest, Please login with new password',
  PWD_RESET_INVALIDCODE:
    'Invalid URL or URL is expired, Please request again for reset password.',
}

export default MESSAGES
